import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import userService from "../../services/userService";

export const getAnnouncements = createAsyncThunk(
    "announcements/getAnnouncements",
    async () => {
        const response = await userService.getAllAnnouncements();
        return response.data;
    }
);

// export const markNotificationAllRead = createAsyncThunk(
//     "notification/markNotificationAllRead",
//     async () => {
//         const response = await userService.markNotificationsAllRead();
//         return response.data;
//     }
// );

const initialState = {
    loading: false,
    announcements: '',
 //   notificationDescription: '',
    unreadMsgs: ''
};

const announcementSlice = createSlice({
    name: "announcement",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAnnouncements.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAnnouncements.fulfilled, (state, action) => {
            state.loading = false;
            state.announcements = action.payload.announcements.announcements;
         //   state.notificationDescription = action.payload.notificationDescriptions;
            state.unreadMsgs = action.payload.announcements.totalUnReadAnnouncements;
        });
        builder.addCase(getAnnouncements.rejected, (state, action) => {
            state.loading = false;
        });
        // builder.addCase(markNotificationAllRead.pending, (state, action) => {
        //     state.loading = true;
        // });
        // builder.addCase(markNotificationAllRead.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.notifications = action.payload.notifications;
        //     state.notificationDescription = action.payload.notificationDescriptions;
        //     state.unreadMsgs = action.payload.totalUnReadNotifications;
        // });
        // builder.addCase(markNotificationAllRead.rejected, (state, action) => {
        //     state.loading = false;
        // });
    }
});

export default announcementSlice.reducer;